import {
  batch,
  createCorpHeadersMiddleware,
  createCsrfMiddleware,
  fetch as fetchBase,
} from '@yandex-delivery/core/utils/network'
import {pipe} from '@yandex-delivery/utils'

import {appConfig} from '../config'
import {extendUrlByBasename} from '../utils'
import {
  createAccountRedirectMiddleware,
  createCargoApiUrlMiddleware,
  createPassportMiddleware,
} from './middlewares'

// ------ TYPES ------
export type FetchFunction = typeof fetchBase

// ------ CONSTANTS ------
const CSRF_TOKEN_ENDPOINT_URL = extendUrlByBasename('api/csrf_token/')

// ------ MIDDLEWARES INITIALIZATION ------
const withCsrfMiddleware = createCsrfMiddleware({
  url: CSRF_TOKEN_ENDPOINT_URL,
})

const withPassportMiddleware = createPassportMiddleware({
  host: appConfig.passportApiHost,
})

const withHeadersMiddleware = createCorpHeadersMiddleware({
  version: appConfig.version,
  lang: appConfig.lang,
  getURI() {
    return `${window.location.origin}${window.location.pathname}`
  },
})

const withAccountRedirectMiddleware = createAccountRedirectMiddleware({
  url: appConfig.accountUrl,
})

const withCargoApiUrlMiddleware = createCargoApiUrlMiddleware()

// ------ FETCH ------
const fetch = pipe(
  //
  fetchBase,
  // @ts-expect-error<TS2345> - типы Fetch не соответствуют друг другу
  withCsrfMiddleware,
  withAccountRedirectMiddleware,
  withHeadersMiddleware,
  batch,
) as FetchFunction

const passportFetch = pipe(
  //
  fetchBase,
  withPassportMiddleware,
) as FetchFunction

const cargoCorpFetch = pipe(
  //
  fetchBase,
  // @ts-expect-error<TS2345> - типы Fetch не соответствуют друг другу
  withCsrfMiddleware,
  withAccountRedirectMiddleware,
  withCargoApiUrlMiddleware,
  withHeadersMiddleware,
  batch,
) as FetchFunction

// ------ EXPORTS ------
export {cargoCorpFetch, fetch, passportFetch}
